export const obfuscateSensitiveField = (key, value) => {
  try {
    const obfuscatedValue = '***';

    if (key.includes('Authorization')) {
      return obfuscatedValue;
    } else if (key.includes('cookie')) {
      return value
        .split(';')
        .map((part) => {
          if (part.includes('oken') || part.includes('__session')) {
            const [key] = part.trim().split('=');
            return `${key}=***`;
          }

          return part;
        })
        .join(';');
    }
  } catch {
    // do nothing
  }

  return value;
};
